// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/list-filter.js';

import { paths } from '../generated/list-filter';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('list-filter', Original, paths);
